module.exports = __webpack_public_path__ + "img/6.9c2b6950.jpg";